import { useState } from 'react';

import { HopBiMatKhoaApi } from '../components/HopBiMatKhoaApi';
import { HopTaoKhoaApi } from '../components/HopTaoKhoaApi';
import { HopThuHoiKhoaApi } from '../components/HopThuHoiKhoaApi';
import type { ApiKey, ApiKeyCreated } from '../types';
import { useTaoKhoaApi, useThuHoiKhoaApi } from './useKhoaApi';

/**
 * Hộp thoại và mutation của màn Khoá API — tạo, hiện bí mật một lần, thu hồi.
 * Cùng khuôn `useThaoTacVaiTro`: trả hàm mở từng việc và `hopThoai` để view
 * đặt vào cây. Mỗi lần mở tăng `lan`, dùng làm `key`: form dựng lại sạch.
 *
 * Bí mật chỉ nằm trong state của hook này tới khi hộp đóng, không vào cache
 * của TanStack Query, không vào URL hay `localStorage`.
 */
export function useThaoTacKhoaApi() {
  const tao = useTaoKhoaApi();
  const thuHoi = useThuHoiKhoaApi();

  const [hopTao, setHopTao] = useState({ mo: false, lan: 0 });
  const [vuaTao, setVuaTao] = useState<ApiKeyCreated | null>(null);
  const [hopThuHoi, setHopThuHoi] = useState<{ mo: boolean; khoa: ApiKey | null }>({ mo: false, khoa: null });

  const dongThuHoi = () => {
    setHopThuHoi((h) => ({ ...h, mo: false }));
    thuHoi.reset();
  };

  const hopThoai = (
    <>
      <HopTaoKhoaApi
        key={`tao-${hopTao.lan}`}
        open={hopTao.mo}
        dangGui={tao.isPending}
        onClose={() => setHopTao((h) => ({ ...h, mo: false }))}
        onTao={(du) =>
          tao.mutateAsync(du).then((kq) => {
            setHopTao((h) => ({ ...h, mo: false }));
            setVuaTao(kq);
          })
        }
      />
      <HopBiMatKhoaApi vuaTao={vuaTao} onClose={() => setVuaTao(null)} />
      <HopThuHoiKhoaApi
        open={hopThuHoi.mo}
        khoa={hopThuHoi.khoa}
        dangChay={thuHoi.isPending}
        loi={thuHoi.error}
        onClose={dongThuHoi}
        onXacNhan={(k) => thuHoi.mutate(k, { onSuccess: () => setHopThuHoi((h) => ({ ...h, mo: false })) })}
      />
    </>
  );

  return {
    moTao: () => setHopTao((h) => ({ mo: true, lan: h.lan + 1 })),
    moThuHoi: (khoa: ApiKey) => {
      // Lỗi của lần trước (có thể của khoá khác) không được hiện ở hộp mới.
      thuHoi.reset();
      setHopThuHoi({ mo: true, khoa });
    },
    hopThoai,
  };
}
